import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthenticationRouter } from './authentication-routing.module';
import { StoreModule } from '@ngrx/store';
import { reducer } from './store/state';
import { ReactiveFormsModule} from '@angular/forms';
import {EffectsModule} from '@ngrx/effects';
import {AuthenticationEffects} from './store/authentication.effects';
import {AngularFireAuthModule} from '@angular/fire/auth';
import {RegisterContainerComponent} from './containers/register/register-container.component';
import {RegisterComponent} from './components/register/register.component';
import {RegistrationSuccessfulComponent} from './containers/registration-successful/registration-successful.component';
import {SharedModule} from '../shared/shared.module';
import { LoginContainerComponent } from './containers/login/login-container.component';
import { LoginComponent } from './components/login/login.component';

@NgModule({
  declarations: [
    RegisterComponent, RegistrationSuccessfulComponent, RegisterContainerComponent, LoginContainerComponent, LoginComponent
  ],
  imports: [
    CommonModule,
    AngularFireAuthModule,
    AuthenticationRouter,
    ReactiveFormsModule,
    SharedModule,
    StoreModule.forFeature('auth', reducer),
    EffectsModule.forFeature([AuthenticationEffects])
  ]
})
export class AuthenticationModule { }
